import { useEffect, useState } from 'react'
import Editor, { Toolbar } from 'react-simple-wysiwyg'

const HospitalRecordsFreeType = ({
  patientDBdata,
  patientID,
  setPatientDBdata,
  noteActualId,
}) => {
  const [tempHtml, setTempHtml] = useState('')
  const [originalHtml, setOriginalHtml] = useState('')
  const [metadataId, setMetadataId] = useState(null)

  useEffect(() => {
    const historyId =
      patientDBdata?.currentNote?.data?.metadata?.historyId

    setMetadataId(historyId ?? null)

    const history =
      patientDBdata?.hospitalRecords?.Data?.[0]?.History || ''

    const html = `
      <div>
      <div>${history || '-'}</div>
      </div>
    `

    const savedFreeType =
      patientDBdata?.currentNote?.data?.freeTypesEverything
        ?.hospitalRecordsFreetype

        console.log(savedFreeType,'savedFreeType')

    setOriginalHtml(html)
    setTempHtml(savedFreeType || html)
  }, [patientDBdata, patientID])

  const handleBlur = () => {
    setPatientDBdata((prev) => ({
      ...prev,
      currentNote: {
        ...prev.currentNote,
        data: {
          ...prev.currentNote.data,
          freeTypesEverything: {
            ...prev.currentNote.data?.freeTypesEverything,
            hospitalRecordsFreetype: tempHtml,
          },
        },
      },

      allNotes: prev.allNotes?.map((note) => {
        if (note.id !== noteActualId) return note

        const parsedData = note.data ? JSON.parse(note.data) : {}

        return {
          ...note,
          data: JSON.stringify({
            ...parsedData,
            freeTypesEverything: {
              ...parsedData.freeTypesEverything,
              hospitalRecordsFreetype: tempHtml,
            },
          }),
        }
      }),
    }))
  }

    useEffect(() => {
    if (!metadataId) return

    const alreadySaved =
      patientDBdata?.currentNote?.data?.freeTypesEverything
        ?.hospitalRecordsFreetype

    if (alreadySaved) return

    if (!originalHtml) return

    setPatientDBdata((prev) => ({
      ...prev,
      currentNote: {
        ...prev.currentNote,
        data: {
          ...prev.currentNote.data,
          freeTypesEverything: {
            ...prev.currentNote.data?.freeTypesEverything,
            hospitalRecordsFreetype: originalHtml,
          },
        },
      },

      allNotes: prev.allNotes?.map((note) => {
        if (note.id !== noteActualId) return note

        const parsed = note.data ? JSON.parse(note.data) : {}

        return {
          ...note,
          data: JSON.stringify({
            ...parsed,
            freeTypesEverything: {
              ...parsed.freeTypesEverything,
              hospitalRecordsFreetype: originalHtml,
            },
          }),
        }
      }),
    }))
  }, [metadataId, originalHtml])



  if (!metadataId) return null

  return (
    <>
      <div className="d-flex">
        <div style={{ width: '30%' }}>Hospital Records</div>

        <div className="w-100">
          <Editor
            value={tempHtml}
            onChange={(e) => setTempHtml(e.target.value)}
            onBlur={handleBlur}
            containerProps={{
              style: {
                width: '100%',
                background: '#2D2D2D',
                color: 'white',
                border: 0,
              },
            }}
          >
            <Toolbar hidden />
          </Editor>
        </div>
      </div>

      <hr />
    </>
  )
}

export default HospitalRecordsFreeType
